import React, { useState, forwardRef, useImperativeHandle, useEffect, useRef } from "react";
import Category from "./Category";
import { IconPlus } from '@tabler/icons-react'
import StepperNavigationButtons from "../../../MyInvitations/Common/StepperNavigationButtons";

const Categories = forwardRef(
  function Categories(props, ref) {
    const [categories, setCategories] = useState([]);

    useEffect(() => {
      if (props.data) {
        setCategoriesData(props.data);
      }
    }, [props.data]);

    const setCategoriesData = (data) => {
      let categoriesData = [];
      data.forEach((item, index) => {
        categoriesData.push({
          title: item.title,
          show: index == 0,
          isValid: false,
          ref: null
        })
      });

      setCategories(categoriesData);
    }

    const handleAddCategory = () => {
      let category =
      {
        title: "Category " + (categories.length + 1),
        show: true,
        isValid: false,
        ref: null
      }

      setCategories(currentCategories => {
        currentCategories.forEach((category) => {
          category["show"] = false;
        });
        let newCategories = [...currentCategories, category];
        return newCategories
      });
    }

    const showHideCategory = (index) => {
      const currentCategories = [...categories];

      currentCategories.forEach((category, innerIndex) => {
        if (index == innerIndex)
          category["show"] = !category["show"];
        else
          category["show"] = false;
      });

      setCategories(currentCategories);
    }

    const deleteCategoryHandler = (targetIndex) => {
      const filteredCategories = categories.filter((item, index) => index !== targetIndex);

      if (filteredCategories.length == 1) {
        filteredCategories[0]["show"] = true;
      }
      else {
        filteredCategories.forEach((category, index) => {
          if (index == targetIndex - 1)
            category["show"] = true;
        });
      }
      setCategories(filteredCategories);
    }

    const validate = () => {
      let isValid = true;
      const currentCategories = [...categories];
      currentCategories.forEach(category => {
        let validationStatus = category.ref?.validate() ?? false;
        category["isValid"] = validationStatus;

        if (!validationStatus) {
          isValid = false;
        }
      });
      setCategories(currentCategories);
      return isValid;
    }

    const getData = () => {
      let categoriesData = [];

      categories.forEach(category => {
        let data = category.ref?.getData() ?? null;
        if (data)
          categoriesData.push(data);
      });

      return categoriesData;
    }

    useImperativeHandle(ref, () => ({
      getData: getData,
      validate: validate
    }));


    return (
      <div className="content d-block visible">
        <div className="content-header mb-3 d-flex justify-content-between">
          <div className="sec-titler">
            <h2 className="text-primary">Categories</h2>
            <div className="title-shape"></div>
            <small className="fs-11 mb-0"></small>
          </div>
          <div className="mb-0 text-right">
            <button className="btn btn-primary align-middle" onClick={handleAddCategory}>
              <IconPlus className="me-sm-1 me-0" size={20} />
              Add Category
            </button>
          </div>
        </div>
        <form>
          <div className="row g-3">
            <div className="accordion mt-3">
              {
                (!categories || (categories && categories.length == 0)) && (
                  <div className="row justify-content-center">
                    <div className="col-md-5 col-lg-4 col-11">
                      <div className="d-flex flex-column align-items-center">
                        <img src="/images/nodata.svg" />
                        <div className="helper-message">
                          No Categories information<br /> Get started by creating
                        </div>
                        <button type="button" className="mt-2 btn btn-primary btn btn-secondary" onClick={handleAddCategory}>
                          <IconPlus className="me-sm-1 me-0" size={20} />
                          Add Category
                        </button>
                      </div>
                    </div>
                  </div>
                )
              }

              {categories && categories.length > 0 &&
                categories.map((category, index) => {
                  return (
                    <Category
                      data={category}
                      index={index}
                      showHideCategory={showHideCategory}
                      deleteCategory={deleteCategoryHandler}
                      key={index}
                      ref={el => category.ref = el}
                      showDelete={true} />
                  )
                })
              }
            </div>

            <StepperNavigationButtons index={props.index} steps={props.steps} navigate={props.navigate} />
          </div>
        </form>
      </div>
    )
  });

export default Categories;
